var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircleGrey02 = function SvgXCircleGrey02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2.45,
    y: 2,
    fill: "#E8E8E8",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303742",
    d: "M17.092 6.887a.6.6 0 0 1 .848.847l-4.267 4.267 4.267 4.266a.6.6 0 0 1-.848.85l-4.267-4.268-4.266 4.267a.6.6 0 0 1-.848-.849l4.265-4.266-4.265-4.267a.599.599 0 1 1 .848-.847l4.266 4.265z"
  })));
};
export default SvgXCircleGrey02;